class GidSetting {
  constructor(conf = {}) {
    this.gid = conf.gid
    this.simpleSignup = conf.simpleSignup || conf.simple_signup
    this.krpcSimpleSignup = conf.krpcSimpleSignup || conf.krpc_simple_signup
    this.jppcSimpleSignup = conf.jppcSimpleSignup || conf.jppc_simple_signup
    this.arenaSimpleSignup = conf.arenaSimpleSignup || conf.arena_simple_signup
    this.krpcMemberAccessCode = conf.krpcMemberAccessCode || conf.krpc_member_access_code
    this.jppcGm = conf.jppcGm || conf.jppc_gm
    this.authSelector = conf.authSelector || conf.auth_selector
  }
}

export default GidSetting
